import React, { useContext, useState } from "react";
import { Helmet } from "react-helmet";
import BreadCrumb from "../others/BreadCrumb";
import { LanguageContext } from "../context/LangaugeContext";
import translations from "../data/langData";
const Contact = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  return (
    <>
      <Helmet>
        <title>{t.contact}</title>
      </Helmet>
      <BreadCrumb title={t.contact} />
      <div className="content-wraper pb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-sm-12">
              <div className="contact-form">
                <div className="contact-form-info">
                <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2412.0155345626113!2d49.89027823524752!3d40.387819250068475!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40307d5d530f9761%3A0xca5ecf034265485d!2zQcSfIFNhcmF5IFJlc2lkZW5jZSwgUWFyYWJhxJ8gQXRsYXLEsSBtZXlkYW7EsQ!5e0!3m2!1str!2saz!4v1782128700097!5m2!1str!2saz"
        title="Google Map"
        width="100%"
        height="450"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-sm-12">
              <div className="contact-infor">
                <div className="contact-title">
                  <h3>{t.contact}</h3>
                </div>
                <div className="contact-dec">
                  <p>{t.contactDesc}</p>
                </div>
                <div className="contact-address">
                  <ul>
                    <li>
                      <i className="fa fa-fax"> </i> {t.address} : Azərbaycan Bakı şəhəri, Ağ Şəhər, Qarabağ Atları Meydanı
                    </li>
                    <li>
                      <i className="fa fa-phone">&nbsp;</i>*8989
                    </li>
                    <li>
                      <a href="mailto:info@xor.az">
                        <i className="fa fa-envelope-o">&nbsp;</i> info@xor.az
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="work-hours">
                  <h3>
                    <strong>{t.working}</strong>
                  </h3>
                  <p>
                    <strong>{t.monday}</strong>: &nbsp; {t.am}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
